import { EN_MESSAGES } from './catalogs/en';

export const SUPPORTED_LOCALES = ['en', 'es', 'fr', 'ar', 'zh-Hans', 'de', 'pt'] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: Locale = 'en';

export type MessageKey = keyof typeof EN_MESSAGES;
export type MessagesCatalog = Record<MessageKey, string>;

export { EN_MESSAGES };

export const RTL_LOCALES = new Set<Locale>(['ar']);
